<template>
  <PageTable goodsMarker="F" @openEditPage="openEditPage" />
</template>

<script>
import lodash from 'lodash'
import { mapState, mapActions } from 'vuex'
import PageTable from '@/views/factory/quality/production-inspection/components/table'
export default {
  name: 'quality-packaging-inspection',
  components: { PageTable },
  computed: { ...mapState('admin/page', { openedPage: 'opened' }) },
  methods: {
    ...mapActions('admin/page', { closePage: 'close' }),
    openEditPage({ pageType, params = {}, query = {} }) {
      const name = 'quality-packaging-inspection-detail'

      if (lodash.isEqual(pageType, 'add')) {
        const open = lodash.find(this.openedPage, (t) => {
          return (
            lodash.isEqual(t.name, name) &&
            lodash.isEqual(t.params?.pageType, pageType)
          )
        })

        if (open) this.closePage({ tagName: open.fullPath, showConfirm: false })
      }

      this.$router.push({
        name,
        params: { pageType, ...params },
        query,
      })
    },
  },
}
</script>
